export default __webpack_public_path__ + "static/media/Lightning.0da18b73.svg";